const initialState = {
  addresses: [],
  isLoading: false,
};

const addresses = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default addresses;
